import Home from './Home.module.css'
import Order from './Order.module.css'
import Voucher from './Voucher.module.css'

export default {
	Home,
	Order,
	Voucher
}
